/**
 * Route for `branch-network-partner-postback`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BranchNetworkPartnerPostbackPage } from "../features/branch-network-partner-postback/BranchNetworkPartnerPostbackPage";

export const branchNetworkPartnerPostbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/branch-network-partner-postback",
	component: BranchNetworkPartnerPostbackPage,
});

export default branchNetworkPartnerPostbackRoute;
